/* XEED FC — motion system（reveal / hero intro / parallax / offscreen pause）
   方針: transform と opacity のみ。低電力端末を考慮して filter/blur は使わない。
   prefers-reduced-motion では全て静止表示。JS無効時は CSS 側で初期状態＝表示。 */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { root.classList.add('xf-reduce'); } else { root.classList.add('xf-js'); }

  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  /* 初期状態が「一度描画されてから」クラスを付けないと transition が走らない（キャッシュ即時読み込み時の定番）。
     二重rAF＋強制リフローで確実に1フレーム挟む。 */
  var afterPaint = function (fn) { raf(function () { void document.body.offsetHeight; raf(fn); }); };

  if (!reduce) {
  /* ---- 文字分割（data-split）: 見出しを1文字ずつ span 化して stagger できるようにする ---- */
  document.querySelectorAll('[data-split]').forEach(function (el) {
    if (el.getAttribute('data-split-done')) return;
    var text = el.textContent; var frag = document.createDocumentFragment(); var i = 0;
    text.split('').forEach(function (ch) {
      var sp = document.createElement('span'); sp.className = 'xf-ch'; sp.textContent = ch;
      if (ch === ' ') sp.classList.add('xf-ch--sp');
      sp.style.setProperty('--i', i++); frag.appendChild(sp);
    });
    el.setAttribute('aria-label', text); el.textContent = ''; el.appendChild(frag); el.setAttribute('data-split-done', '1');
  });

  /* ---- reveal（data-reveal）---- */
  var revealEls = [].slice.call(document.querySelectorAll('[data-reveal]'));
  // 兄弟同士のスタッガー: data-reveal-group を持つ親の子は index に応じて遅延
  document.querySelectorAll('[data-reveal-group]').forEach(function (g) {
    var step = parseFloat(g.getAttribute('data-reveal-group')) || 60;
    [].slice.call(g.children).forEach(function (el, i) {
      if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
      if (!el.style.getPropertyValue('--xf-delay')) el.style.setProperty('--xf-delay', Math.min(i * step, 900) + 'ms');
      if (revealEls.indexOf(el) < 0) revealEls.push(el);
    });
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- 画面外では無限アニメーションを止める（data-pv / data-band）---- */
  var loops = [].slice.call(document.querySelectorAll('[data-pv], [data-band]'));
  if ('IntersectionObserver' in window && loops.length) {
    var lo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target.hasAttribute('data-band')) { if (e.isIntersecting) { e.target.classList.add('is-inview'); lo.unobserve(e.target); } return; }
        e.target.classList.toggle('is-inview', e.isIntersecting);
      });
    }, { rootMargin: '10% 0px 10% 0px' });
    loops.forEach(function (el) { lo.observe(el); });
  } else {
    loops.forEach(function (el) { el.classList.add('is-inview'); });
  }

  /* ---- hero intro ---- */
  var hero = document.querySelector('.xf-hero');
  if (hero) {
    /* KV画像のデコードとフォント確定を待ってから開始する。
       ページ全体の load を待つと遅すぎ、固定タイマーだと「見る前に終わっている」ため。
       最大4秒で必ず開始、非表示タブなら見えた瞬間に開始、既にスクロール済みなら演出せず即表示。 */
    var fired = false;
    var start = function () { if (fired) return; fired = true; afterPaint(function () { hero.classList.add('is-ready'); }); };
    var startWhenVisible = function () {
      if (document.hidden) {
        document.addEventListener('visibilitychange', function h() {
          if (!document.hidden) { document.removeEventListener('visibilitychange', h); raf(start); }
        });
        return;
      }
      start();
    };
    if ((window.scrollY || 0) > 320) {
      hero.classList.add('xf-no-intro', 'is-kv'); start(); // 途中から見ている人にはポップさせない
    } else {
      var waits = [];
      var kv = hero.querySelector('.xf-hero__photo img');
      // 写真そのものの登場は「画像が届いた瞬間」に紐づける（通信が遅くても必ず見える）
      var markKv = function () { afterPaint(function () { hero.classList.add('is-kv'); }); };
      if (kv) {
        if (kv.complete && kv.naturalWidth) markKv();
        else { kv.addEventListener('load', markKv, { once: true }); kv.addEventListener('error', markKv, { once: true }); }
      } else { markKv(); }
      if (kv) {
        if (kv.complete && kv.naturalWidth) {
          if (kv.decode) { try { waits.push(kv.decode().catch(function () {})); } catch (e) {} }
        } else {
          waits.push(new Promise(function (r) {
            kv.addEventListener('load', function () { (kv.decode ? kv.decode().catch(function () {}) : Promise.resolve()).then(r); }, { once: true });
            kv.addEventListener('error', r, { once: true });
          }));
        }
      }
      if (document.fonts && document.fonts.ready) waits.push(document.fonts.ready.catch(function () {}));
      if (waits.length) Promise.all(waits).then(startWhenVisible); else startWhenVisible();
      setTimeout(startWhenVisible, 4000); // 保険（画像が極端に遅い/失敗した場合）
    }
  }

  /* ---- pointer parallax（PC・ホバー端末のみ）: ヒーローの写真/文字/スタンプが視線を追う ---- */
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1081px)').matches;
  if (finePointer && hero) {
    var layers = [
      [hero.querySelector('.xf-hero__brand'), 6],
      [hero.querySelector('.xf-hero__photo'), 14],
      [hero.querySelector('.xf-hero__text'), 10],
      [hero.querySelector('.xf-hero__stamp'), 22]
    ].filter(function (l) { return l[0]; });
    var tx = 0, ty = 0, cx = 0, cy = 0, animating = false;
    var step = function () {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      layers.forEach(function (l) { l[0].style.setProperty('--px', (cx * l[1]).toFixed(2) + 'px'); l[0].style.setProperty('--py', (cy * l[1]).toFixed(2) + 'px'); });
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) raf(step); else animating = false;
    };
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5; ty = (e.clientY - r.top) / r.height - 0.5;
      if (!animating) { animating = true; raf(step); }
    });
    hero.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!animating) { animating = true; raf(step); } });
  }

  /* ---- card tilt（PC・ホバー端末のみ）: コンテンツカードがポインタに合わせてわずかに傾く ---- */
  if (finePointer) {
    document.querySelectorAll('.xf-coming__card').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--rx', (-y * 4).toFixed(2) + 'deg'); card.style.setProperty('--ry', (x * 5).toFixed(2) + 'deg');
        card.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%'); card.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () { card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---- scroll progress bar ---- */
  var prog = document.createElement('div'); prog.className = 'xf-progress'; prog.setAttribute('aria-hidden', 'true'); document.body.appendChild(prog);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && hero) hero.classList.add('xf-no-intro', 'is-ready', 'is-kv');
  });

  /* ---- header state（パララックスは CSS scroll-driven animation に移行）---- */
  var header = document.querySelector('.xf-header');
  var ticking = false;
  /* スクロール・パララックス（全ブラウザ）: 要素ごとの係数で --sy を書く */
  /* 係数と最大移動量（px）。Open!はテキストの子なので個別に動かさない（二重にかかって離れていく） */
  var parLayers = hero ? [
    [hero.querySelector('.xf-hero__brand'), 0.03, 40],
    [hero.querySelector('.xf-hero__photo'), 0.12, 140],
    [hero.querySelector('.xf-hero__text'), 0.05, 60]
  ].filter(function (l) { return l[0]; }) : [];
  var bandEl = hero ? hero.querySelector('.xf-hero__band') : null;
  var parOn = window.matchMedia && window.matchMedia('(min-width: 1081px)').matches;
  function onScroll() {
    if (ticking) return; ticking = true;
    raf(function () {
      ticking = false; var y = window.scrollY || 0;
      if (header) header.classList.toggle('is-scrolled', y > 24);
      if (prog) { var max = document.documentElement.scrollHeight - window.innerHeight; prog.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0).toFixed(4) + ')'; }
      if (parOn && y < 1800) {
        for (var i = 0; i < parLayers.length; i++) parLayers[i][0].style.setProperty('--sy', Math.min(y * parLayers[i][1], parLayers[i][2]).toFixed(1) + 'px');
        if (bandEl) bandEl.style.setProperty('--xf-band-y', (-Math.min(y * 0.07, 90)).toFixed(1) + 'px');
      }
    });
  }
  window.addEventListener('resize', function () { parOn = window.matchMedia('(min-width: 1081px)').matches; }, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  }

  /* ---- SP menu ---- */
  var mbtn = document.querySelector('.xf-header__menu');
  var mpanel = document.getElementById('XfMenu');
  if (mbtn && mpanel) {
    var setOpen = function (open) {
      mbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      mpanel.hidden = !open;
      raf(function () { mpanel.classList.toggle('is-open', open); });
      root.classList.toggle('xf-menu-open', open);
    };
    mbtn.addEventListener('click', function () { setOpen(mbtn.getAttribute('aria-expanded') !== 'true'); });
    mpanel.addEventListener('click', function (e) { if (e.target.closest('a') || e.target.hasAttribute('data-close')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mpanel.hidden) { setOpen(false); mbtn.focus(); } });
  }

  /* ---- member profile dialog（前後ナビ・矢印キー・スワイプ対応）---- */
  var dlg = document.getElementById('XfMemberDialog');
  if (dlg && typeof dlg.showModal === 'function') {
    var members = [].slice.call(document.querySelectorAll('[data-member]'));
    var fields = ['name', 'no', 'role', 'genre', 'bday', 'profile', 'comment'];
    var cur = -1, lastBtn = null, swapping = false;
    var fill = function (btn) {
      fields.forEach(function (f) { var el = dlg.querySelector('[data-f="' + f + '"]'); if (el) { var v = btn.getAttribute('data-' + f) || ''; el.textContent = v; if (f === 'comment') el.hidden = !v; } });
      ['ig', 'x'].forEach(function (f) { var a = dlg.querySelector('[data-f="' + f + '"]'); var v = btn.getAttribute('data-' + f); if (a) { if (v) { a.href = v; a.hidden = false; } else { a.hidden = true; } } });
      // 写真: まず一覧で読み込み済みの中サイズ（即表示）→ 大サイズを裏で読み込んで差し替え。前後の人の大サイズは先読み
      var img = dlg.querySelector('.xf-mdl__photo img');
      if (img) {
        var large = btn.getAttribute('data-photo') || '', mid = btn.getAttribute('data-photo-mid') || large;
        img.alt = btn.getAttribute('data-name') || '';
        img.src = mid; img.dataset.want = large;
        var pre = new Image(); pre.decoding = 'async'; pre.onload = function () { if (img.dataset.want === large) img.src = large; }; pre.src = large;
      }
      var idx = members.indexOf(btn);
      [1, -1, 2, -2].forEach(function (d) { var m = members[(idx + d + members.length) % members.length]; if (m) { var pi = new Image(); pi.src = m.getAttribute('data-photo'); } });
      // 一覧タイルと同じトリミング（タイルの配置変数をそのまま写す）
      var tile = btn.closest('.xf-mem'), ph = dlg.querySelector('.xf-mdl__photo'); if (tile && ph) { ph.style.cssText = tile.style.cssText; ph.style.setProperty('--p', '0'); }
      // 背面の斜めバンドは人が変わるたびに走り直す（transitionでなくanimationなので付け直しで必ず再生される）
      var band = dlg.querySelector('.xf-mdl__band');
      if (band) { band.classList.remove('is-in'); void band.offsetWidth; band.classList.add('is-in'); }
      var panel = dlg.querySelector('.xf-mdl__panel'); if (panel) panel.scrollTop = 0;
      var ix = dlg.querySelector('[data-f="idx"]'), tt = dlg.querySelector('[data-f="total"]');
      if (ix) ix.textContent = String(members.indexOf(btn) + 1).padStart(2, '0'); if (tt) tt.textContent = String(members.length).padStart(2, '0');
    };
    var openDlg = function (btn) {
      lastBtn = btn; cur = members.indexOf(btn); fill(btn);
      dlg.showModal(); root.classList.add('xf-menu-open');
      raf(function () { dlg.classList.add('is-open'); });
    };
    var step = function (dir) {
      if (!dlg.open || swapping || members.length < 2) return;
      swapping = true; var next = (cur + dir + members.length) % members.length;
      dlg.classList.add(dir > 0 ? 'is-out-left' : 'is-out-right');
      setTimeout(function () {
        cur = next; fill(members[cur]);
        dlg.classList.remove('is-out-left', 'is-out-right'); dlg.classList.add(dir > 0 ? 'is-in-right' : 'is-in-left');
        raf(function () { raf(function () { dlg.classList.remove('is-in-right', 'is-in-left'); swapping = false; }); });
      }, 220);
    };
    var closeDlg = function () {
      dlg.classList.remove('is-open'); root.classList.remove('xf-menu-open');
      setTimeout(function () { if (dlg.open) dlg.close(); if (members[cur]) members[cur].focus(); }, 200);
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-member]'); if (b) { e.preventDefault(); openDlg(b); return; }
      var nav = e.target.closest('[data-nav]'); if (nav && dlg.open) { step(parseInt(nav.getAttribute('data-nav'), 10) || 1); return; }
      if (e.target.closest('[data-close]') && dlg.open) { closeDlg(); return; }
      if (e.target === dlg && dlg.open) closeDlg(); // backdrop click
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDlg(); });
    // SP: パネルのスクロール量 → 写真の奥行き（--p 0..1）
    var panelEl = dlg.querySelector('.xf-mdl__panel'), photoEl = dlg.querySelector('.xf-mdl__photo'), pTick = false;
    if (panelEl && photoEl) panelEl.addEventListener('scroll', function () {
      if (pTick) return; pTick = true;
      raf(function () { pTick = false; var h = photoEl.offsetHeight || 1; photoEl.style.setProperty('--p', Math.min(1, panelEl.scrollTop / (h * 0.55)).toFixed(3)); });
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!dlg.open) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    var sx = null, sy = null;
    dlg.addEventListener('touchstart', function (e) { var t0 = e.touches[0]; sx = t0.clientX; sy = t0.clientY; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null) return; var t1 = e.changedTouches[0]; var dx = t1.clientX - sx, dy = t1.clientY - sy; sx = sy = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---- countdown ---- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = Date.parse(el.getAttribute('data-countdown')); if (isNaN(target)) return;
    var f = { d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'), m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]') };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = Math.max(0, target - Date.now()); var sec = Math.floor(diff / 1000);
      var d = Math.floor(sec / 86400), h = Math.floor(sec % 86400 / 3600), m = Math.floor(sec % 3600 / 60), s = sec % 60;
      var set = function (node, v) { if (!node || node.textContent === String(v)) return; node.textContent = v; node.classList.remove('is-tick'); void node.offsetWidth; node.classList.add('is-tick'); };
      set(f.d, d); set(f.h, pad(h)); set(f.m, pad(m)); set(f.s, pad(s));
      if (diff > 0) setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    tick();
  });

  /* ---- copy guard（タレント肖像の保護。完全防止は不可能だが、できる抑止は全部入れる）---- */
  (function guard() {
    if (window.Shopify && window.Shopify.designMode) return; // テーマエディタ内では無効
    var isEditable = function (el) { return el && el.closest && el.closest('input, textarea, select, [contenteditable="true"]'); };
    // 右クリック / 長押しメニュー
    document.addEventListener('contextmenu', function (e) { if (!isEditable(e.target)) e.preventDefault(); }, { capture: true });
    // 画像ドラッグ・選択・コピー
    document.addEventListener('dragstart', function (e) { if (!isEditable(e.target)) e.preventDefault(); }, { capture: true });
    document.addEventListener('selectstart', function (e) { if (!isEditable(e.target)) e.preventDefault(); }, { capture: true });
    document.addEventListener('copy', function (e) { if (!isEditable(e.target)) { e.preventDefault(); try { e.clipboardData.setData('text/plain', 'Anker XEED OFFICIAL FAN CLUB — https://xeed.ankerjapan.com/'); } catch (x) {} } }, { capture: true });
    document.addEventListener('cut', function (e) { if (!isEditable(e.target)) e.preventDefault(); }, { capture: true });
    // 画像に draggable=false（DOM追加分も含めて）
    var noDrag = function (root) { (root.querySelectorAll ? root.querySelectorAll('img') : []).forEach(function (im) { im.setAttribute('draggable', 'false'); }); };
    noDrag(document);
    if ('MutationObserver' in window) new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'IMG') n.setAttribute('draggable', 'false'); noDrag(n); } }); }); }).observe(document.documentElement, { childList: true, subtree: true });
    // ショートカット（保存 / ソース表示 / 印刷 / 開発ツール）
    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toLowerCase(); var mod = e.metaKey || e.ctrlKey;
      if (isEditable(e.target) && !(mod && (k === 's' || k === 'u' || k === 'p'))) return;
      if (mod && ['s', 'u', 'p'].indexOf(k) >= 0) { e.preventDefault(); return; }
      if (mod && e.shiftKey && ['i', 'j', 'c'].indexOf(k) >= 0) { e.preventDefault(); return; }
      if (mod && e.altKey && ['i', 'j', 'c', 'u'].indexOf(k) >= 0) { e.preventDefault(); return; }
      if (k === 'f12') { e.preventDefault(); return; }
    }, { capture: true });
    // 印刷（Cmd+P以外の経路）: 印刷時は中身を隠す（CSS側 @media print）＋ beforeprint で警告
    window.addEventListener('beforeprint', function () { document.documentElement.classList.add('xf-printing'); });
    window.addEventListener('afterprint', function () { document.documentElement.classList.remove('xf-printing'); });
    root.classList.add('xf-guard');
  })();
  /* ---- Vimeo ファサード: サムネをクリックしたときだけプレイヤーを生成 ---- */
  document.addEventListener('click', function (e) {
    var f = e.target.closest('.xf-video__facade'); if (!f) return;
    var box = f.closest('.xf-video'); var id = box && box.getAttribute('data-vimeo'); if (!id || box.classList.contains('is-locked')) return;
    var ifr = document.createElement('iframe');
    ifr.src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&title=0&byline=0&portrait=0&dnt=1';
    ifr.allow = 'autoplay; fullscreen; picture-in-picture'; ifr.setAttribute('allowfullscreen', ''); ifr.title = 'video';
    box.innerHTML = ''; box.appendChild(ifr);
  });

  /* ---- Vimeo サムネ: 記事画像が無い動画は Vimeo のサムネを自動で入れる（記事画像があればそちらが優先＝手動指定） ---- */
  document.querySelectorAll('img[data-vimeo-thumb]').forEach(function (img) {
    var id = img.getAttribute('data-vimeo-thumb'); var w = img.getAttribute('data-w') || '1280';
    var key = 'xf-vthumb:' + id, cached = null;
    var put = function (u) { img.src = u.replace(/-d_\d+(x\d+)?/, '-d_' + w); img.hidden = false; };
    try { cached = sessionStorage.getItem(key); } catch (er) {}
    if (cached) { put(cached); return; }
    fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.thumbnail_url) return;
        try { sessionStorage.setItem(key, d.thumbnail_url); } catch (er) {}
        put(d.thumbnail_url);
      }).catch(function () {});
  });

  /* ---- プラン: 月額/年額切替 ---- */
  var cyc = document.querySelector('[data-cycle]');
  if (cyc) {
    var setCycle = function (c) {
      cyc.querySelectorAll('[data-cycle-btn]').forEach(function (b) { var on = b.getAttribute('data-cycle-btn') === c; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      document.querySelectorAll('[data-cycle-m]').forEach(function (el) { el.hidden = c !== 'm'; });
      document.querySelectorAll('[data-cycle-y]').forEach(function (el) { el.hidden = c !== 'y'; });
    };
    cyc.addEventListener('click', function (e) { var b = e.target.closest('[data-cycle-btn]'); if (b) setCycle(b.getAttribute('data-cycle-btn')); });
  }

  /* ---- 新着（鮮度）: 前回の訪問で見た分は点/NEWを消し、未読の投稿を強調。localStorage のみ・失敗しても無害 ---- */
  (function freshness() {
    var KEY = 'xf_seen:';
    function get(h) { try { return +localStorage.getItem(KEY + h) || 0; } catch (e) { return 0; } }
    function set(h, v) { try { localStorage.setItem(KEY + h, String(v)); } catch (e) {} }
    [].slice.call(document.querySelectorAll('[data-fresh][data-ts]')).forEach(function (el) {
      if (get(el.getAttribute('data-fresh')) >= +el.getAttribute('data-ts')) el.hidden = true;
    });
    var page = document.querySelector('[data-fresh-page]'); if (!page) return;
    var h = page.getAttribute('data-fresh-page'); if (!h) return;
    var seen = get(h), max = 0, unread = 0;
    [].slice.call(document.querySelectorAll('[data-item-ts]')).forEach(function (it) {
      var ts = +it.getAttribute('data-item-ts'); if (ts > max) max = ts;
      if (seen && ts > seen) { it.classList.add('is-unread'); unread++; }
    });
    var u = document.querySelector('[data-unread]');
    if (u && unread) { u.hidden = false; var n = u.querySelector('[data-unread-n]'); if (n) n.textContent = unread; }
    if (max > seen) setTimeout(function () { set(h, max); }, 2500);
  })();

  /* ---- PHOTO GALLERY: アルバム → コンタクトシート（一覧）→ タイルからズームインして拡大表示 ---- */
  (function gallery() {
    var gal = document.querySelector('[data-gal]'); if (!gal) return;
    var cards = [].slice.call(gal.querySelectorAll('.xf-gal__card'));
    var dlg = document.getElementById('XfGalleryDialog'); if (!dlg || typeof dlg.showModal !== 'function') return;

    var sheet = dlg.querySelector('[data-gsheet]'), tiles = dlg.querySelector('[data-gtiles]');
    var lb = dlg.querySelector('[data-glb]'), gtrack = dlg.querySelector('[data-gtrack]');
    var zoom = dlg.querySelector('[data-gzoom]');
    var q = function (n) { return dlg.querySelector('[data-g="' + n + '"]'); };
    var raf = function (f) { if (window.requestAnimationFrame) window.requestAnimationFrame(f); else f(); };
    var raf2 = function (f) { raf(function () { raf(f); }); };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var cur = -1;           /* 開いているアルバム */
    var srcs = [];          /* そのアルバムの写真 */
    var slides = [], k = -1, flying = false;

    /* Shopify CDN の width を付け替える（元URLに width が付いていても最後の1つに揃える） */
    var at = function (src, w) {
      if (!src) return '';
      var u = src.replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    };
    var thumb = function (s) { return at(s, 600); };
    var big = function (s) { return at(s, 2000); };

    /* 写真の src を文書順に。章立てのアルバムは <i data-gch> が章の切れ目（chaps[写真の番号] = 章名） */
    var chaps = {}, starts = [];
    /* 拡大表示中は、いまの写真の章（例: 02 パフォーマンス）を下のバーに出す */
    var chapAt = function (j) { var n = ''; starts.forEach(function (st, x) { if (st <= j) n = String(x + 1).padStart(2, '0') + ' ' + chaps[st]; }); return n; };
    var photosOf = function (i) {
      chaps = {};
      var tpl = cards[i].querySelector('[data-album-photos]'); if (!tpl) return [];
      var frag = tpl.content ? tpl.content : tpl, out = [], pend = null;
      [].slice.call(frag.querySelectorAll('img, [data-gch]')).forEach(function (el) {
        if (el.hasAttribute('data-gch')) { pend = el.getAttribute('data-gch'); return; }
        var s = el.getAttribute('src') || el.getAttribute('data-src') || ''; if (!s) return;
        if (pend !== null) { chaps[out.length] = pend; pend = null; }
        out.push(s);
      });
      return out;
    };
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

    /* ---- FLIP: from の矩形から to の矩形へ1枚の画像を飛ばす ---- */
    var fly = function (from, to, src, ms, done) {
      if (!from || !to || reduce) { done(); return; }
      zoom.innerHTML = '<img src="' + src + '" alt="">';
      zoom.hidden = false;
      zoom.style.transition = 'none';
      zoom.style.left = from.left + 'px'; zoom.style.top = from.top + 'px';
      zoom.style.width = from.width + 'px'; zoom.style.height = from.height + 'px';
      flying = true;
      /* 背面タブでは rAF が止まるので、タイマーでも同じ処理を仕掛けておく（開いたまま固まらないための保険） */
      var started = false;
      var start = function () {
        if (started) return; started = true;
        zoom.style.transition = 'left ' + ms + 'ms cubic-bezier(.22,1,.36,1), top ' + ms + 'ms cubic-bezier(.22,1,.36,1), width ' + ms + 'ms cubic-bezier(.22,1,.36,1), height ' + ms + 'ms cubic-bezier(.22,1,.36,1)';
        zoom.style.left = to.left + 'px'; zoom.style.top = to.top + 'px';
        zoom.style.width = to.width + 'px'; zoom.style.height = to.height + 'px';
        setTimeout(function () { flying = false; done(); }, ms);
      };
      raf2(start); setTimeout(start, 80);
    };
    var landed = function () { zoom.hidden = true; zoom.innerHTML = ''; zoom.style.transition = 'none'; };
    /* FLIP のあいだ隠したタイルを全部戻す（拡大→別の写真→一覧、と辿ったときに消し残らないように） */
    var unhideTiles = function () { [].slice.call(tiles.querySelectorAll('.is-hidden')).forEach(function (b) { b.classList.remove('is-hidden'); }); };
    var rectOf = function (el) { if (!el) return null; var r = el.getBoundingClientRect(); return { left: r.left, top: r.top, width: r.width, height: r.height }; };

    /* ---- コンタクトシート ---- */
    var buildSheet = function (i) {
      cur = i; var c = cards[i];
      q('who').textContent = c.getAttribute('data-who') || c.getAttribute('data-title') || '';
      q('sub').textContent = c.getAttribute('data-sub') || c.getAttribute('data-date') || '';
      srcs = photosOf(i);
      var cv = c.getAttribute('data-cover') || '';
      if (!srcs.length) { if (cv) srcs = [cv]; }
      /* 章立てのアルバムは表紙（集合写真など）を先頭に全幅で置く。拡大表示でも 01 枚目として見られる */
      var lead = c.hasAttribute('data-lead') && cv && srcs.length;
      if (lead) {
        var shifted = {}; Object.keys(chaps).forEach(function (n) { shifted[+n + 1] = chaps[n]; }); chaps = shifted;
        srcs.unshift(cv);
      }
      q('total').textContent = String(srcs.length).padStart(2, '0');
      q('lbtotal').textContent = String(srcs.length).padStart(2, '0');
      var who = c.getAttribute('data-who') || '';
      /* 章ごとの枚数（見出しの右に出す） */
      starts = Object.keys(chaps).map(Number).sort(function (a, b) { return a - b; });
      var chapN = {}; starts.forEach(function (st, x) { chapN[st] = (x + 1 < starts.length ? starts[x + 1] : srcs.length) - st; });
      tiles.innerHTML = srcs.map(function (s, j) {
        /* スタッガーは頭の数十枚だけ（数百枚でも最後まで待たされないように） */
        var d = Math.min(j, 24) * 26;
        var head = '';
        if (chaps[j] !== undefined) {
          var no = String(starts.indexOf(j) + 1).padStart(2, '0');
          head = '<li class="xf-gmdl__chap" style="--d:' + d + 'ms"><span class="xf-gmdl__chapno xf-en">' + no + '</span>' +
            '<h3 class="xf-gmdl__chapttl">' + esc(chaps[j]) + '</h3>' +
            '<span class="xf-gmdl__chapn xf-en">' + String(chapN[j]).padStart(2, '0') + ' PHOTOS</span></li>';
        }
        return head + '<li class="xf-gmdl__tile' + (lead && j === 0 ? ' xf-gmdl__tile--lead' : '') + '" role="listitem">' +
          '<button type="button" class="xf-gmdl__tilebtn" data-tile="' + j + '" style="--d:' + d + 'ms" aria-label="' + who + ' ' + (j + 1) + ' を拡大">' +
          '<img src="' + (lead && j === 0 ? at(s, 1600) : thumb(s)) + '" alt="' + who + ' ' + (j + 1) + '" loading="' + (j < 12 ? 'eager' : 'lazy') + '" decoding="async">' +
          '<span class="xf-gmdl__tileno xf-en">' + String(j + 1).padStart(2, '0') + '</span>' +
          '</button></li>';
      }).join('');
      sheet.scrollTop = 0;
      try { history.replaceState(null, '', '#album-' + c.getAttribute('data-handle')); } catch (e) {}
    };

    var chrome = function () {
      var h = dlg.querySelector('.xf-gmdl__head'), b = dlg.querySelector('.xf-gmdl__lbbar');
      dlg.style.setProperty('--gm-chrome', ((h ? h.offsetHeight : 0) + (b ? b.offsetHeight : 0) + 24) + 'px');
    };
    window.addEventListener('resize', function () { if (dlg.open) chrome(); });

    /* ---- 開く: アルバムの表紙から画面いっぱいへ広がり、そのあと一覧がスタッガーで立ち上がる ---- */
    var open = function (i, fromEl) {
      buildSheet(i);
      dlg.classList.remove('is-lb', 'is-sheet-in'); lb.hidden = true;
      dlg.showModal(); root.classList.add('xf-menu-open'); chrome();
      var cover = fromEl && fromEl.querySelector('img');
      var from = rectOf(cover);
      var to = rectOf(dlg.querySelector('.xf-gmdl__panel'));
      var show = function () { dlg.classList.add('is-open'); chrome(); };
      raf(show); setTimeout(show, 60);
      if (from && to && !reduce) {
        fly(from, to, cover.currentSrc || cover.src, 520, function () {
          zoom.style.transition = 'opacity .32s ease'; zoom.style.opacity = '0';
          dlg.classList.add('is-sheet-in');
          setTimeout(function () { landed(); zoom.style.opacity = ''; }, 340);
        });
      } else {
        var sheetIn = function () { dlg.classList.add('is-sheet-in'); };
        raf2(sheetIn); setTimeout(sheetIn, 80);
      }
    };

    var close = function () {
      dlg.classList.remove('is-open', 'is-sheet-in', 'is-lb');
      root.classList.remove('xf-menu-open'); landed(); unhideTiles();
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      setTimeout(function () {
        if (dlg.open) dlg.close();
        lb.hidden = true;
        var b = cards[cur] && cards[cur].querySelector('[data-open]'); if (b) b.focus();
      }, 240);
    };

    /* ---- 拡大表示 ---- */
    var slideImg = function (j) { return slides[j] && slides[j].querySelector('img'); };
    var loadWindow = function (c0) {
      slides.forEach(function (sl, j) {
        var im = sl.querySelector('img'); if (!im) return;
        if (Math.abs(j - c0) <= 2) {
          var want = j === c0 ? big(srcs[j]) : thumb(srcs[j]);
          if (im.getAttribute('data-at') !== want) { im.src = want; im.setAttribute('data-at', want); }
        }
      });
    };
    var setIdx = function (j) {
      k = j;
      q('idx').textContent = String(j + 1).padStart(2, '0');
      var cq = q('chap'); if (cq) cq.textContent = chapAt(j);
      var arrows = lb.querySelectorAll('[data-gnav]');
      arrows[0].disabled = j <= 0; arrows[1].disabled = j >= slides.length - 1;
      loadWindow(j);
    };
    var idxFromScroll = function () { var w = gtrack.clientWidth || 1; return Math.round(gtrack.scrollLeft / w); };
    gtrack.addEventListener('scroll', function () { if (!flying) setIdx(idxFromScroll()); }, { passive: true });
    var go = function (d) {
      var w = gtrack.clientWidth;
      var j = Math.max(0, Math.min(slides.length - 1, idxFromScroll() + d));
      gtrack.scrollTo({ left: j * w, behavior: reduce ? 'auto' : 'smooth' });
    };

    var buildLb = function () {
      var who = cards[cur] ? (cards[cur].getAttribute('data-who') || '') : '';
      gtrack.innerHTML = srcs.map(function (s, j) {
        return '<div class="xf-gmdl__slide" data-slide="' + j + '"><img alt="' + who + ' ' + (j + 1) + '" decoding="async"></div>';
      }).join('');
      slides = [].slice.call(gtrack.children);
    };

    /* タイル → 拡大: タイルの位置から、拡大後の実寸位置へズームイン */
    var openLb = function (j) {
      if (flying) return;
      var btn = tiles.querySelector('[data-tile="' + j + '"]');
      var from = rectOf(btn);
      buildLb();
      lb.hidden = false; chrome();
      /* まずサムネで描いて最終位置を実測（キャッシュ済みなので即描画される） */
      var im = slideImg(j); if (im) { im.src = thumb(srcs[j]); im.setAttribute('data-at', thumb(srcs[j])); }
      gtrack.scrollLeft = j * (gtrack.clientWidth || 1);
      var finish = function () {
        dlg.classList.add('is-lb');
        setIdx(j);
        landed();
        gtrack.focus({ preventScroll: true });
      };
      var start = function () {
        var to = rectOf(im);
        if (!to || !to.width) { finish(); return; }
        if (btn) btn.classList.add('is-hidden');
        fly(from, to, thumb(srcs[j]), 480, finish);
      };
      var started2 = false;
      var once = function () { if (started2) return; started2 = true; start(); };
      if (im && !im.complete) { im.addEventListener('load', function () { raf(once); setTimeout(once, 40); }, { once: true }); setTimeout(once, 600); }
      else { raf2(once); setTimeout(once, 80); }
    };

    /* 拡大 → 一覧: いま見ている写真から、対応するタイルへ戻る */
    var backToSheet = function () {
      if (flying) return;
      var j = k < 0 ? 0 : k;
      var im = slideImg(j);
      var btn = tiles.querySelector('[data-tile="' + j + '"]');
      if (btn) { btn.scrollIntoView({ block: 'center', behavior: 'auto' }); btn.classList.add('is-hidden'); }
      var from = rectOf(im), to = rectOf(btn);
      var finish = function () {
        landed();
        unhideTiles();
        if (btn) btn.focus({ preventScroll: true });
        lb.hidden = true;
      };
      dlg.classList.remove('is-lb');
      if (from && to && im) fly(from, to, im.currentSrc || im.src, 420, finish); else finish();
    };

    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open]');
      if (o) { e.preventDefault(); open(parseInt(o.getAttribute('data-open'), 10), o.closest('.xf-gal__card')); return; }
      if (!dlg.open) return;
      var t = e.target.closest('[data-tile]'); if (t) { openLb(parseInt(t.getAttribute('data-tile'), 10)); return; }
      var n = e.target.closest('[data-gnav]'); if (n) { go(parseInt(n.getAttribute('data-gnav'), 10)); return; }
      if (e.target.closest('[data-gback]')) { backToSheet(); return; }
      if (e.target.closest('[data-gclose]')) { close(); return; }
      if (e.target === dlg) close();
    });
    dlg.addEventListener('cancel', function (e) {
      e.preventDefault();
      if (dlg.classList.contains('is-lb')) backToSheet(); else close();
    });
    document.addEventListener('keydown', function (e) {
      if (!dlg.open || !dlg.classList.contains('is-lb')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    /* 直リンク #album-<handle> */
    var m = (location.hash || '').match(/^#album-(.+)$/);
    if (m) {
      var i = cards.findIndex(function (c) { return c.getAttribute('data-handle') === decodeURIComponent(m[1]); });
      if (i > -1) setTimeout(function () { open(i, cards[i]); }, 300);
    }
  })();

  /* ---- TALK ROOM: メンバーで絞り込み（クリックで選択・もう一度でリセット）---- */
  (function talkFilter() {
    var feed = document.querySelector('[data-feed]'); if (!feed) return;
    var btns = [].slice.call(document.querySelectorAll('[data-filter]'));
    var resets = [].slice.call(document.querySelectorAll('[data-filter-reset]'));
    var bar = document.querySelector('.xf-talk__filterbar'), label = document.querySelector('[data-filter-label]');
    var allBtn = document.querySelector('.xf-talk__allbtn');
    var posts = [].slice.call(feed.querySelectorAll('.xf-post'));
    var cur = null;
    // ページ送りは全投稿基準なので、絞り込み中は隠して他ページの投稿も取り込んで出す
    // （今のページの20件だけ絞ると「数件なのに 1 / 2」になり、他ページの投稿も見えない）
    var pager = feed.querySelector('[data-pager]');
    var pageNow = pager ? +pager.getAttribute('data-page') || 1 : 1;
    var pageMax = pager ? +pager.getAttribute('data-pages') || 1 : 1;
    var loading = null;
    var loadAll = function () {
      if (loading) return loading;
      var reqs = [];
      for (var n = 1; n <= pageMax; n++) {
        if (n === pageNow) continue;
        (function (n) {
          var u = new URL(location.href); u.searchParams.set('page', n); u.hash = '';
          reqs.push(fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var f = doc.querySelector('[data-feed]');
            return { n: n, items: f ? [].slice.call(f.querySelectorAll('.xf-post')) : [] };
          }).catch(function () { return { n: n, items: [] }; }));
        })(n);
      }
      loading = Promise.all(reqs).then(function (pages) {
        var first = feed.querySelector('.xf-post');
        pages.sort(function (a, b) { return a.n - b.n; }).forEach(function (pg) {
          pg.items.forEach(function (p) {
            if (document.getElementById(p.id)) return;
            var el = document.importNode(p, true);
            el.classList.add('is-extra', 'is-in'); el.setAttribute('data-reveal', '');
            feed.insertBefore(el, pg.n < pageNow ? first : pager);
            posts.push(el);
          });
        });
      });
      return loading;
    };
    var apply = function (key) {
      cur = key;
      if (key && pageMax > 1 && !loading) { loadAll().then(function () { if (cur) apply(cur); }); }
      if (pager) pager.hidden = !!key;
      posts.forEach(function (p) {
        var show = key ? p.getAttribute('data-key') === key : !p.classList.contains('is-extra');
        p.classList.toggle('is-hidden', !show);
      });
      btns.forEach(function (b) {
        var on = b.getAttribute('data-filter') === key;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var n = posts.filter(function (p) { return !p.classList.contains('is-hidden'); }).length;
      if (bar) bar.hidden = !key;
      if (allBtn) allBtn.hidden = !key;
      var cur_btn = btns.filter(function (b) { return b.getAttribute('data-filter') === key; })[0];
      var disp = cur_btn ? (cur_btn.querySelector('.xf-en:not(.xf-talk__mav)') || cur_btn).textContent.trim() : (key || '');
      if (label) label.textContent = key ? (disp.toUpperCase() + ' — ' + (n === 0 ? 'NO POSTS YET' : n + ' POST' + (n === 1 ? '' : 'S'))) : '';
      feed.classList.toggle('is-filtered', !!key);
    };
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-filter');
        apply(cur === k ? null : k);
        if (cur) { var t = feed.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: t, behavior: 'smooth' }); }
      });
    });
    resets.forEach(function (r) { r.addEventListener('click', function () { apply(null); }); });
  })();
  /* ---- TOPのNEWS: モーダルで読む（前後移動・スワイプ・最後にVIEW ALL）---- */
  (function newsModal() {
    var dlg = document.getElementById('XfNewsDialog'); if (!dlg || typeof dlg.showModal !== 'function') return;
    var links = [].slice.call(document.querySelectorAll('[data-news]')); if (!links.length) return;
    var cur = -1, swapping = false;
    var q = function (n) { return dlg.querySelector('[data-n="' + n + '"]'); };
    var fill = function (i) {
      var a = links[i]; if (!a) return;
      cur = i;
      q('date').textContent = a.getAttribute('data-date') || '';
      var cat = a.getAttribute('data-cat') || ''; var catEl = q('cat');
      catEl.textContent = cat; catEl.hidden = !cat;
      q('title').textContent = a.getAttribute('data-title') || '';
      q('permalink').href = a.getAttribute('data-url') || '#';
      q('idx').textContent = String(i + 1).padStart(2, '0');
      q('total').textContent = String(links.length).padStart(2, '0');
      var img = a.getAttribute('data-image'), fig = q('figure');
      if (img) { fig.querySelector('img').src = img; fig.hidden = false; } else { fig.hidden = true; }
      var ok = a.getAttribute('data-ok') === '1';
      var tpl = a.parentNode.querySelector('[data-news-body]');
      q('content').innerHTML = ok && tpl ? tpl.innerHTML : '';
      q('content').hidden = !ok;
      q('lock').hidden = ok;
      // CRF 9/15 p3: 本文をこのモーダルで全部見せている（＝記事ページに追加情報がない）ときは
      // 記事ページへの導線を出さない。ロック中・本文が空のときだけ記事ページへ送る。
      var pl = q('permalink');
      if (pl) pl.hidden = ok && !!(q('content').textContent || '').trim();
      if (!ok) q('lockneed').textContent = 'MEMBERS ONLY — ' + (a.getAttribute('data-need') || '').toUpperCase();
      q('all').hidden = i < links.length - 1; // 最後まで見たら一覧へ誘導
      dlg.querySelector('.xf-nmdl__body').scrollTop = 0;
    };
    var open = function (i) { fill(i); dlg.showModal(); root.classList.add('xf-menu-open'); raf(function () { dlg.classList.add('is-open'); }); };
    var close = function () { dlg.classList.remove('is-open'); root.classList.remove('xf-menu-open'); setTimeout(function () { if (dlg.open) dlg.close(); if (links[cur]) links[cur].focus(); }, 200); };
    var step = function (d) {
      if (swapping || links.length < 2) return; swapping = true;
      var next = (cur + d + links.length) % links.length;
      dlg.classList.add(d > 0 ? 'is-out-left' : 'is-out-right');
      setTimeout(function () {
        fill(next);
        dlg.classList.remove('is-out-left', 'is-out-right'); dlg.classList.add(d > 0 ? 'is-in-right' : 'is-in-left');
        raf(function () { raf(function () { dlg.classList.remove('is-in-right', 'is-in-left'); swapping = false; }); });
      }, 200);
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-news]');
      if (a) { e.preventDefault(); open(links.indexOf(a)); return; }
      var n = e.target.closest('[data-nnav]');
      if (n && dlg.open) { step(parseInt(n.getAttribute('data-nnav'), 10) || 1); return; }
      if (e.target.closest('[data-nclose]') && dlg.open) { close(); return; }
      var inner = e.target.closest('.xf-nmdl__content a[href]');
      if (inner && dlg.open) {
        var h = inner.getAttribute('href') || '';
        if (h.charAt(0) === '#' || h.indexOf('/#') === 0) { close(); }
        return;
      }
      if (e.target === dlg && dlg.open) close();
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    document.addEventListener('keydown', function (e) {
      if (!dlg.open) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    var sx = null, sy = null;
    dlg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = sy = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    }, { passive: true });
  })();
  /* --- 会員証プレビュー: ?card=free|trial|vip|vipyear でデザインを見比べる（社内確認用） --- */
  (function () {
    var v = (new URLSearchParams(location.search)).get('card');
    if (!v) return;
    var map = { free: ['FREE', '無料会員'], trial: ['TRIAL', 'トライアル会員'], vip: ['VIP', 'VIP会員（月額）'], vipyear: ['VIP ANNUAL', 'VIP会員（年額）'] };
    if (!map[v]) return;
    var card = document.querySelector('.xf-card'); if (!card) return;
    card.className = card.className.replace(/xf-card--\w+/, 'xf-card--' + v);
    var rank = card.querySelector('.xf-rank');
    if (rank) { rank.className = rank.className.replace(/xf-rank--\w+/, 'xf-rank--' + v); rank.textContent = map[v][0]; }
    document.querySelectorAll('.xf-page__lead, .xf-row dd').forEach(function (el) {
      el.textContent = el.textContent.replace(/(無料会員|トライアル会員|VIP会員(（月額）|（年額）)?)/, map[v][1]);
    });
  })();
  /* ---- 本文内の埋め込み動画: width/height 属性から実比率を CSS 変数へ（既定 16:9 は CSS 側）---- */
  [].slice.call(document.querySelectorAll('.xf-rte iframe, .xf-rte video')).forEach(function (f) {
    var w = +f.getAttribute('width'), h = +f.getAttribute('height');
    if (w > 0 && h > 0) f.style.setProperty('--xf-ar', w + ' / ' + h);
  });

  /* ---- イベント事前予約の完了モーダル（送信成功時にサーバ側が出力し、ここで開く）---- */
  (function doneModal() {
    var d = document.getElementById('XfDoneDialog'); if (!d) return;
    var open = function () { if (typeof d.showModal === 'function') { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } } else { d.setAttribute('open', ''); } };
    if (d.hasAttribute('data-autoopen')) setTimeout(open, 120);
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-close]')) { d.close ? d.close() : d.removeAttribute('open'); }
    });
  })();
})();

/* ---- TOP MOVIE（sections/xeed-fc-movie-hero）----
   1) 読み込み: ページ load 完了後、見えている or 1画面手前（下から近づく時）だけ src を入れる。
      通り過ぎて画面外に出たら src を外して転送を止め、戻ってきたら続きから再開。読み込むのは常に1本
   2) 画質（pickSrc）: 「画面の実ピクセル幅で要る画質」と「回線で出せる上限」の低い方。安定回線＋広い画面なら 1080p
      回線 = Network Information API の downlink と、ページ自身の画像の実測速度（Resource Timing）の大きい方
      Safari は HLS をネイティブ再生（回線と表示サイズで自動調整）
   3) 30%以上見えている間だけ無音で play、外れたら pause。タブ非表示でも pause
   4) ポスターは <img> を重ね、再生が始まったらフェードアウト（.is-playing）
   5) スクロールは固定しない。入ってくる間の進捗を --fp に書き、開き切ったら .is-open（文字は一度だけ登場）
   省データ設定 / reduced-motion / 低電力モード等で play が拒否されたら再生ボタンを出す */
(function () {
  'use strict';
  var films = document.querySelectorAll('[data-film]');
  if (!films.length) return;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduce = !!(mq && mq.matches);
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
  var slow = function () { return !!conn && (!!conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '')); };
  var hasIO = 'IntersectionObserver' in window;

  /* ページ自身が今回ネットワークから取った大きめのリソースの実測速度（Mbps）。キャッシュ分（transferSize 0）は除外 */
  var measuredMbps = function () {
    if (!window.performance || !performance.getEntriesByType) return 0;
    var best = 0;
    performance.getEntriesByType('resource').forEach(function (e) {
      var bytes = e.encodedBodySize || 0, ms = e.responseEnd - e.responseStart;
      if (e.transferSize > 0 && bytes >= 40000 && ms > 4) { var m = bytes * 8 / ms / 1000; if (m > best) best = m; }
    });
    return best;
  };
  /* 画質選択。途中で切り替えると二重に読み込むので、読み込みごとに1回だけ決める */
  var pickSrc = function (video) {
    var d = video.dataset;
    if (slow()) return d.srcSd;
    // Safari（回線APIなし＋HLSネイティブ）は HLS に任せる
    if (!conn && d.srcHls && video.canPlayType('application/vnd.apple.mpegurl')) return d.srcHls;
    var px = (window.innerWidth || 1280) * Math.min(window.devicePixelRatio || 1, 3);
    var need = px > 1400 ? 3 : (px > 900 ? 2 : 1);                 // 画面幅で要る画質 3=1080p 2=720p 1=480p
    var bw = Math.max(conn && conn.downlink || 0, measuredMbps()); // Mbps
    var cap = bw === 0 ? 2 : (bw >= 6 ? 3 : (bw >= 2.5 ? 2 : 1));   // 回線の上限（不明なら 720p まで）
    var q = Math.min(need, cap);
    return q === 3 ? d.srcHd : (q === 2 ? d.srcMd : d.srcSd);
  };

  [].forEach.call(films, function (sec) {
    var frame = sec.querySelector('.xf-film__frame');
    var video = sec.querySelector('.xf-film__video');
    var playBtn = sec.querySelector('.xf-film__play');
    var soundBtn = sec.querySelector('.xf-film__sound');
    if (!video) return;
    var autoplay = !reduce && !slow();
    var loaded = false, visible = false, userPaused = false, resumeAt = 0;

    /* KV など初期表示の画像・フォントと帯域を取り合わないよう、ページの load 完了までは src を入れない */
    var pageReady = document.readyState === 'complete', wantLoad = false;
    if (!pageReady) window.addEventListener('load', function () { pageReady = true; if (wantLoad) setTimeout(load, 0); }, { once: true });
    var load = function () {
      if (loaded) return;
      if (!pageReady) { wantLoad = true; return; }
      loaded = true;
      video.src = pickSrc(video) || video.dataset.srcMd;
      video.preload = autoplay ? 'auto' : 'metadata';
      video.load();
      if (visible) sync();
    };
    /* 画面外へ出たら src を外してバッファと転送を捨てる。位置は覚えておき、次の load で続きから */
    var unload = function () {
      wantLoad = false;
      if (!loaded) return;
      loaded = false;
      if (video.currentTime) resumeAt = video.currentTime;
      video.pause();
      video.removeAttribute('src');
      video.load();
      sec.classList.remove('is-playing');
    };
    video.addEventListener('loadedmetadata', function () {
      if (resumeAt > 0 && resumeAt < (video.duration || 0)) { try { video.currentTime = resumeAt; } catch (e) {} }
    });
    video.addEventListener('playing', function () { sec.classList.add('is-playing'); });
    var showPlay = function (on) { if (playBtn) playBtn.hidden = !on; };
    var play = function () {
      load();
      if (!loaded) return; // ページ load 後に load() 内の sync() から再開
      var p = video.play();
      if (p && p.catch) p.then(function () { showPlay(false); }).catch(function () { showPlay(true); });
    };
    var sync = function () {
      if (visible && !document.hidden && !userPaused && (autoplay || !video.paused)) { if (video.paused) play(); }
      else if (!video.paused) video.pause();
    };
    if (!autoplay) showPlay(true);

    if (playBtn) playBtn.addEventListener('click', function () { userPaused = false; autoplay = true; play(); });
    video.addEventListener('click', function () {
      if (video.paused) { userPaused = false; autoplay = true; play(); } else { userPaused = true; video.pause(); showPlay(true); }
    });
    if (soundBtn) soundBtn.addEventListener('click', function () {
      var on = video.muted;
      video.muted = !on; if (on) { video.volume = 1; userPaused = false; autoplay = true; play(); }
      soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', on ? '音声をオフにする' : '音声をオンにする');
    });
    document.addEventListener('visibilitychange', sync);

    if (hasIO) {
      /* near: 上下1画面以内 / onScreen: 1px でも見えている。下から近づく時だけ先読み、通り過ぎたら解放 */
      var near = false, below = true, onScreen = false;
      var decide = function () { if (onScreen || (near && below)) load(); else unload(); };
      new IntersectionObserver(function (es) { near = es[0].isIntersecting; below = es[0].boundingClientRect.top > 0; decide(); }, { rootMargin: '100% 0px 100% 0px' }).observe(sec);
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; below = es[0].boundingClientRect.top > 0; decide(); }).observe(sec);
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; sync(); }, { threshold: 0.3 }).observe(frame || video);
    } else { load(); visible = true; sync(); }

    /* ---- スクロール連動（ピン留めなし）----
       セクション上端が画面下端に来た時 0、ヘッダー直下（SP は画面中央付近）に来た時 1。そのまま通り過ぎる */
    if (reduce || !frame) { sec.classList.add('is-open'); return; }
    var active = false, ticking = false, open = false, headerH = 0;
    var measure = function () { headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--xf-header-h')) || 0; };
    var update = function () {
      ticking = false;
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var end = Math.max(headerH, (vh - r.height) / 2);
      var t = (vh - r.top) / Math.max(1, vh - end);
      var fp = Math.max(0, Math.min(1, t));
      fp = 1 - Math.pow(1 - fp, 2); // ease-out
      frame.style.setProperty('--fp', fp.toFixed(4));
      if (!open && fp > 0.9) { open = true; sec.classList.add('is-open'); }
    };
    var onScroll = function () { if (active && !ticking) { ticking = true; window.requestAnimationFrame(update); } };
    if (hasIO) {
      new IntersectionObserver(function (es) { active = es[0].isIntersecting; if (active) onScroll(); }, { rootMargin: '10% 0px 10% 0px' }).observe(sec);
    } else { active = true; }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    measure(); update();
  });
})();
